/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RegistrationsControllerGetCompanyRolesQueryResponse } from "../../models/registrationsController/RegistrationsControllerGetCompanyRoles";

function getRegistrationsControllerGetCompanyRolesUrl() {
  const res = { method: 'GET', url: `/api/v1/registrations/company-roles` as const }  
  return res
}

/**
 * @description Returns the list of predefined company roles for the registration form dropdown.
 * @summary Get predefined company roles
 * {@link /api/v1/registrations/company-roles}
 */
export async function registrationsControllerGetCompanyRoles(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<RegistrationsControllerGetCompanyRolesQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getRegistrationsControllerGetCompanyRolesUrl().url.toString(), ... requestConfig })  
  return res.data
}